module.exports = __webpack_public_path__ + "fonts/NeuePlak-CompBold.f0cc429e.ttf";